import React,{useState} from 'react';
import s from './Link.module.css';
import {Btn} from '../UI/Btn';
import {Icons} from '../Sidebar/Icons';
import {useStore} from '../../hooks/useStore';

export function LinkAgendamento(){
  const {tenant}=useStore();
  const [copied,setCopied]=useState(false);
  const tid=tenant?.id||'demo';
  const link=`${window.location.origin}${window.location.pathname}?c=${tid}`;
  const copy=()=>{navigator.clipboard?.writeText(link).then(()=>{setCopied(true);setTimeout(()=>setCopied(false),2000);});};
  return(
    <div className={s.wrap}><div className={s.card}>
      <div className={s.ic}><Icons.Link/></div>
      <h2 className={s.ti}>Link de Agendamento Online</h2>
      <p className={s.sb}>Compartilhe com seus clientes para que possam agendar diretamente, 24h por dia.</p>
      <div className={s.lb}>{link}</div>
      <div className={s.btns}>
        <Btn icon={copied?<Icons.Check/>:<Icons.Copy/>} onClick={copy} variant={copied?'success':'primary'}>{copied?'Copiado!':'Copiar Link'}</Btn>
        <Btn variant="secondary" onClick={()=>window.open(link,'_blank')}>Visualizar</Btn>
      </div>
      <div className={s.tips}><p className={s.tt}>💡 Como compartilhar:</p><ul><li>Envie pelo WhatsApp para seus clientes</li><li>Bio do Instagram ou TikTok</li><li>Site ou cardápio digital</li></ul></div>
    </div></div>
  );
}
